import { createLogger } from '@immediate_media/script-utils';

export const logger = createLogger('advertising');
